<template>
  <div class="intern-registration">
    <div
      class="popup"
      :style="{ left: `${popupX}px`, top: `${popupY}px` }"
      v-if="!!popupMessage"
      @click="() => (popupMessage = '')"
    >{{ popupMessage }}</div>
    <div class="card" :class="{ activated: cardActivated }">
      <template v-if="state == STATES.SIGN_UP">
        <FormInput
          id="email"
          type="email"
          prompt="Enter your email to get started"
          placeholder="name@gmail.com"
          :error="inputEmailError"
          :warning="inputEmailWarning"
          :onInput="changeEmail"
          :onChange="submitEmail"
          :onPressEnter="submitEmail"
          :onBlur="submitEmail"
        />

        <div class="card-expanding-content-container">
          <Form>
            <FormInput
              id="company"
              type="text"
              prompt="Which company do you work for?"
              placeholder="Google"
              :onClickInfoBtn="onClickInfoBtn"
              infoText="We collect this to better connect you with learners."
              :onInput="changeCompany"
              :onChange="changeCompany"
              :onPressEnter="changeCompany"
              :onBlur="changeCompany"
            />

            <FormInput
              id="city"
              type="text"
              prompt="What city are you in?"
              placeholder="Seattle"
              :onClickInfoBtn="onClickInfoBtn"
              infoText="We collect this to better connect you with learners."
              :onInput="changeGoalCity"
              :onChange="changeGoalCity"
              :onPressEnter="changeGoalCity"
              :onBlur="changeGoalCity"
            />

            <FormButton label="Join" :click="submitForm" :disabled="buttonDisabled" />

            <button
              class="link-button"
              @click="
                (e) =>
                  onClickInfoBtn(
                    e,
                    'The details are only used to facilitate our mentorship program and will never be shared without your explicit permission'
                  )
              "
            >Protecting your info</button>
          </Form>
        </div>
      </template>

      <template v-if="state == STATES.LOADING">
        <p style="text-align: center;">Loading...</p>
      </template>

      <template v-if="state == STATES.SUCCESS">
        <p>
          <b>Thank you!</b>
        </p>
        <p>
          Welcome to the Club!
          <br />Click the button below to sign up to the Slack group
          <br />Please use the same email address that you submitted.
        </p>
        <a class="button" href="https://bit.ly/internclub" target="_blank">Sign me up</a>
      </template>

      <template v-if="state == STATES.FAIL">
        <p>
          <b>Error!</b>
        </p>
        <p>
          Unfortunately, there was a problem submitting your profile. Please
          refresh the page and try again.
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import Form from './Form.vue';
import FormButton from './FormButton.vue';
import FormInput from './FormInput.vue';

const STATES = {
  SIGN_UP: 0,
  LOADING: 1,
  SUCCESS: 2,
  FAIL: 3,
};

export default {
  name: 'MentorRegistration',
  components: {
    Form,
    FormButton,
    FormInput,
  },
  data() {
    return {
      cardActivated: false,
      state: STATES.SIGN_UP,

      inputEmail: '',
      inputEmailError: '',
      inputEmailWarning: '',

      inputCompany: '',
      inputCompanyError: '',

      inputGoalCity: '',
      inputGoalCityError: '',

      popupX: 0,
      popupY: 0,
      popupMessage: '',

      STATES: {
        ...STATES,
      },
    };
  },
  methods: {
    submitEmail(e, inputValue) {
      this.inputEmail = inputValue;
      this.cardActivated = inputValue.length > 0;

      if (this.cardActivated && !/.+@.+\..+/.test(this.inputEmail)) {
        this.inputEmailError = 'Please use a valid email address.';
      }
    },
    changeEmail(e, inputValue) {
      this.inputEmailError = '';
      this.inputEmailWarning = '';

      this.inputEmail = inputValue;
      this.cardActivated = inputValue.length > 0 ? this.cardActivated : false;
      if (!this.cardActivated && /.+@.+\..+/.test(inputValue)) {
        this.cardActivated = true;
      }
    },
    changeGoalCity(e, inputValue) {
      this.inputGoalCity = inputValue;

      if (inputValue.length == 0) {
        this.inputGoalCityError =
          'Please respond to all questions before submitting.';
      }
    },
    changeCompany(e, inputValue) {
      this.inputCompany = inputValue;

      if (inputValue.length == 0) {
        this.inputCompany =
          'Please respond to all questions before submitting.';
      }
    },
    onClickInfoBtn(e, popupMessage) {
      if (this.popupMessage == popupMessage) {
        this.popupMessage = '';
        return;
      }

      this.popupX = e.pageX - 200 - 32;
      this.popupY = e.pageY + 18;
      this.popupMessage = popupMessage;
    },
    submitForm() {
      let endpoint =
        'https://internclub-backend.andreybutenko.com/v1/sign-up/mentor';
      let body = this.postRequest;

      this.state = STATES.LOADING;

      axios
        .post(endpoint, body)
        .then(() => {
          this.state = STATES.SUCCESS;
        })
        .catch((e) => {
          // eslint-disable-next-line
          console.error(e);
          return;
        });
    },
  },
  computed: {
    buttonDisabled() {
      return (
        !/.+@.+\..+/.test(this.inputEmail) ||
        /@gmail\.com$/.test(this.inputEmail) ||
        this.inputCompany.length == 0 ||
        this.inputGoalCity.length == 0
      );
    },
    postRequest() {
      return {
        email: this.inputEmail,
        goalCity: this.inputGoalCity,
        company: this.inputCompany,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_variables';

.intern-registration {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 1.5em;
  max-width: 100%;
  box-sizing: border-box;
  font-family: 'Cabin', sans-serif;

  .card {
    max-width: 100%;

    transition: all 250ms;
    z-index: 999;
    box-sizing: border-box;

    &.activated {
      background-color: #fff;
      padding: 48px;
      border-radius: 8px;
      box-shadow: 0px 16px 56px rgba(86, 77, 123, 0.16);

      .card-expanding-content-container {
        max-height: 9999px;
        opacity: 1;
        visibility: visible;
      }
    }

    .card-expanding-content-container {
      max-height: 0;
      margin: 0;
      padding: 0;
      opacity: 0;
      visibility: hidden;
      transition: all 250ms;
    }
  }

  .button {
    display: block;
    text-decoration: none;
    text-align: center;
    font-family: inherit;
    min-width: 50%;
    box-sizing: border-box;
    border: 1px solid rgba(102, 100, 108, 0.16);
    font-family: 'Cabin', sans-serif;
    background-color: $brand-color;
    color: white;
    border-radius: 4px;
    padding: 16px;
    margin: 8px 0;
  }

  .link-button {
    font-family: inherit;
    margin-top: 16px;
    border: none;
    background: none;
    color: #4b28ce;
    font-size: 16px;
    line-height: 24px;
    text-decoration: underline;
    border: none;
    background: none;
    cursor: pointer;
    align-self: flex-end;
  }
}

.popup {
  position: absolute;
  background-color: #ddd;
  font-size: 0.9em;
  border: 1px solid black;
  padding: 16px;
  width: 200px;
  border-radius: 8px;
  box-shadow: 0px 16px 56px rgba(86, 77, 123, 0.16);
  cursor: pointer;
  z-index: 9999;
  font-family: 'Cabin', sans-serif;
}
</style>
